export const CASH_INSTRUCTION_BASE_QUERY_KEY = 'cash-instruction';

export const cashInstructionApiQueryKeys = {
  all: () => [CASH_INSTRUCTION_BASE_QUERY_KEY] as const,
};
